export enum Auth0Connection {
  google = "google-oauth2",
  outlook = "guides-waad",
  slack = "slack",
}
